import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
const baseClassName = ['flex', 'gap-1', 'flex-col', 'items-start', 'justify-start', 'text-base', 'leading-none', 'text-greyscale-950', 'w-[90%]', '*:data-[slot=file-label]:truncate', '*:data-[slot=file-label]:max-w-[90%]', '*:data-[slot=file-size]:text-sm!', '*:data-[slot=file-size]:leading-none', '*:data-[slot=file-size]:text-greyscale-600', '[&.is-uploading]:relative', '[&.is-uploading]:before:absolute', '[&.is-uploading]:before:inset-y-0', '[&.is-uploading]:before:right-0', '[&.is-uploading]:before:[counter-reset:variable_var(--file-upload-progress,0)]', '[&.is-uploading]:before:content-[counter(variable)"%"]', '[&.is-uploading]:before:text-greyscale-600', '[&.is-uploading]:after:mt-2', '[&.is-uploading]:after:content-[""]', '[&.is-uploading]:after:w-full', '[&.is-uploading]:after:bg-linear-to-r', '[&.is-uploading]:after:from-blue-500', '[&.is-uploading]:after:from-[calc(var(--file-upload-progress,0)*1%)]', '[&.is-uploading]:after:to-[calc(var(--file-upload-progress,0)*1%)]', '[&.is-uploading]:after:to-stone-300', '[&.is-uploading]:after:rounded-full', '[&.is-uploading]:after:h-1', '[&.is-uploading]:after:block', '[&.is-uploading_[data-slot=file-size]]:hidden'].join(' ');
const AttachmentsToolbarItemLabel = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let isUploading;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      isUploading,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = isUploading;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    isUploading = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== isUploading) {
    t1 = classNames(baseClassName, {
      "is-uploading": isUploading
    }, className);
    $[5] = className;
    $[6] = isUploading;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== props || $[10] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};

// eslint-disable-next-line react/display-name
AttachmentsToolbarItemLabel.Size = (props: React.ComponentPropsWithoutRef<'span'>) => <span data-slot="file-size" {...props} />;

// eslint-disable-next-line react/display-name
AttachmentsToolbarItemLabel.Name = (props: React.ComponentPropsWithoutRef<'span'>) => <span data-slot="file-label" {...props} />;
export default AttachmentsToolbarItemLabel;